import { useEffect } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import { isEqual } from "lodash";

import { InvoiceCategory } from "../../../models";
import { invoiceCategorySchema as schema } from "../schemas";
import {
  useAddInvoiceCategory,
  usePatchInvoiceCategory,
} from "../../../hooks/invoice-category";
import { FormContainer } from "../../layout";
import { FormSubmitButton, FormTextField } from "../../form-components";
import { useChangeDetection } from "../../../contexts/ChangeDetectionContext";

interface Props {
  invoiceCategory?: InvoiceCategory;
  onSubmitted?: () => void;
}

export const InvoiceCategoryForm = (props: Props) => {
  const { invoiceCategory, onSubmitted } = props;
  const { setChangeDetection } = useChangeDetection();
  const { mutate: createInvoiceCategory } = useAddInvoiceCategory();
  const { mutate: patchInvoiceCategory } = usePatchInvoiceCategory();
  const {
    control,
    watch,
    handleSubmit,
    formState: { isSubmitting, defaultValues },
  } = useForm<InvoiceCategory>({
    resolver: yupResolver(schema),
    defaultValues: invoiceCategory,
  });

  useEffect(() => {
    const subscription = watch(
      (value, { type }) =>
        type === "change" && setChangeDetection(!isEqual(value, defaultValues))
    );
    return () => subscription.unsubscribe();
  }, [watch]);

  return (
    <FormContainer
      onSubmit={handleSubmit((payment) => {
        payment.id
          ? patchInvoiceCategory(payment)
          : createInvoiceCategory(payment);
        onSubmitted && onSubmitted();
        setChangeDetection(false);
      })}
    >
      <Stack direction="row" spacing={2}>
        <FormTextField name="name" label="Name" control={control} required />
      </Stack>
      <FormSubmitButton disabled={isSubmitting} />
    </FormContainer>
  );
};
